window.app.factory("apiHelper", [
  "apiCall",
  "$q",
  function(apiCall, $q) {
    const cache = {};
    const entityCache = {};
    window.AH = { cache, entityCache };
    return function apiHelper(id, $scope, defs) {
      cache[id] = cache[id] || {};
      defs = { ...defs };

      function paramNames(endpoint) {
        return (endpoint.match(/:([a-zA-Z0-9_]+)/g) || []).map(s =>
          s.substr(1)
        );
      }

      function firstNonNil(values) {
        return values.find(v => v !== undefined && v !== null);
      }

      function replaceParams(string, opts, data = {}) {
        paramNames(string).forEach(name => {
          const val = firstNonNil([
            data[name],
            opts.params && opts.params[name],
            opts[name]
          ]);
          string = string.replace(":" + name, val);
        });
        return string;
      }

      function getConfig(item, opts) {
        return {
          endpoint: defs[item][0],
          ...defs[item][1],
          ...opts
        };
      }

      function getEntity(entity, opts) {
        const data = entityCache[entity.name];
        if (data) {
          if (entity.plural && !data.listed) return;
          const key = replaceParams(entity.key, opts);
          return entity.plural ? data.list : data.map[key];
        }
      }

      function rebuildEntityMap(entity) {
        let entCache = entityCache[entity.name];
        entCache.map = {};
        entCache.list.forEach(item => {
          const key = replaceParams(entity.key, item);
          entCache.map[key] = item;
        });
      }

      function rebuildEntityList(entity) {
        let entCache = entityCache[entity.name];
        entCache.list = [];

        Object.values(entCache.map).forEach(item => {
          entCache.list.push(item);
        });
      }

      function saveEntity(entity, data, opts) {
        const entCache = entityCache[entity.name] || {
          list: [],
          map: {},
          listed: false
        };
        if (entity.plural) {
          entCache.list = data;
          entCache.listed = true;
          entityCache[entity.name] = entCache;
          rebuildEntityMap(entity);
        } else {
          const key = replaceParams(entity.key, { ...opts, ...data });
          if (entity.del) {
            delete entCache.map[key];
          } else {
            entCache.map[key] = data;
          }
          entityCache[entity.name] = entCache;
          rebuildEntityList(entity);
        }
      }

      function get(itemOrItems, opts = {}) {
        if (itemOrItems instanceof Array) {
          return $q.all(itemOrItems.map(item => get(item, opts)));
        }
        const item = itemOrItems;
        const cfg = getConfig(item, opts);

        let promise;
        const useCache = cfg.useCache !== false;
        let endpoint = replaceParams(cfg.endpoint, opts);
        const entity = cfg.entity && getEntity(cfg.entity, opts);

        if (useCache && entity !== undefined) {
          promise = $q.resolve(entity);
        } else if (useCache && cache[id][endpoint] !== undefined) {
          promise = $q.resolve(cache[id][endpoint]);
        } else {
          promise = apiCall({ endpoint }).then(v => {
            if (cfg.filter) {
              v = cfg.filter(v);
            }
            cache[id][endpoint] = v;
            if (cfg.entity) {
              saveEntity(cfg.entity, v);
            }
            return v;
          });
        }

        return promise.then(v => {
          const key = replaceParams(cfg.key || "", v, opts);
          if (key) {
            $scope[item][key] = v;
          } else {
            $scope[item] = v;
          }
          return v;
        });
        // TODO handle errors
      }

      function update(item, data, opts = {}) {
        const newVal = data !== undefined ? data : $scope[item];
        const cfg = { ...getConfig(item), ...opts };
        let endpoint = (cfg.update && cfg.update.endpoint) || cfg.endpoint;
        endpoint = replaceParams(endpoint, opts, data);

        return apiCall({
          endpoint,
          method: (cfg.update && cfg.update.method) || "POST",
          data: newVal
        }).then(v => {
          // TODO maybe API should consistently return sth
          const savedVal = v || newVal;
          $scope[item] = savedVal;
          cache[id][endpoint] = savedVal;

          if (cfg.entity) {
            saveEntity(cfg.entity, savedVal, { ...opts, ...data });
          }

          return v || savedVal;
        });
        // TODO handle errors
      }

      function clearCache(item) {
        if (item) {
          // TODO fix this (won't work anymore)
          cache[id][item] = undefined;
        } else {
          cache[id] = {};
        }
      }

      return { get, update, clearCache, custom: apiCall };
    };
  }
]);

window.app.factory("apiHelper2", [
  "apiCall",
  "$q",
  function(apiCall, $q) {
    const globalCache = {};
    const defaultDefs = {
      C: { name: "create", endpoint: "", method: "POST", update: true },
      G: { name: "get", endpoint: "#", method: "GET" },
      L: {
        name: "list",
        endpoint: "",
        method: "GET",
        plural: true
      } /*, list: true*/,
      U: { name: "update", endpoint: "#", method: "POST", update: true },
      D: { name: "delete", endpoint: "#", method: "DELETE", delete: true }
    };
    window.GC = globalCache;

    function getEmptyCache() {
      return { list: [], map: {}, listed: false };
    }

    return function apiHelper2(entityDef) {
      const {
        name,
        defaultMethods = "CGLUD",
        customMethods,
        baseEndpoint,
        key: keyFormat = ""
      } = entityDef;
      let cache;
      const out = {};

      if (!globalCache[name]) {
        if (entityDef.mock) {
          const savedMockData = JSON.parse(
            localStorage.getItem("_mock_" + name)
          );
          globalCache[name] = {
            list: savedMockData || entityDef.mockData || [],
            map: {},
            listed: true
          };
          cache = globalCache[name];
          rebuildCacheMap();
        } else {
          globalCache[name] = getEmptyCache();
        }
      }
      cache = globalCache[name];

      const methodDefs = {};
      defaultMethods.split("").forEach(l => {
        const def = { ...defaultDefs[l] };
        const name = def.name;
        def.endpoint = baseEndpoint + def.endpoint;
        delete def.name;
        methodDefs[name] = def;
      });

      Object.assign(methodDefs, customMethods);

      function createMethod(def, name) {
        return function(arg1, arg2, arg3) {
          console.warn("simpleApi - called method", {
            entity: entityDef.name,
            method: name,
            arg1,
            arg2,
            arg3
          });
          let promise;
          if (def.update || def.delete) {
            promise = update(def, arg1, arg2, arg3);
          } else {
            promise = get(def, arg1, arg2);
          }
          return promise;
        };
      }

      function paramNames(endpoint) {
        return (endpoint.match(/:([a-zA-Z0-9_]+)/g) || []).map(s =>
          s.substr(1)
        );
      }

      function replaceParams(string, params, urlencode) {
        paramNames(string).forEach(name => {
          string = string.replace(
            ":" + name,
            urlencode ? encodeURIComponent(params[name]) : params[name]
          );
        });
        return string;
      }

      function getCachedEntity(def, params) {
        if (def.plural && !cache.listed) return;
        const key = replaceParams(keyFormat, params);
        return def.plural ? cache.list : cache.map[key];
      }

      function rebuildCacheMap() {
        cache.map = {};
        cache.list.forEach(item => {
          const key = replaceParams(keyFormat, item);
          cache.map[key] = item;
        });
      }

      function rebuildCacheList(entity) {
        cache.list = [];
        Object.values(cache.map).forEach(item => {
          cache.list.push(item);
        });
      }

      function saveEntity(def, data, params) {
        if (def.plural) {
          // NOTE here assuming plural => full list.
          // TODO maybe support separate plural/list handling
          cache.list = data;
          cache.listed = true;
          rebuildCacheMap();
        } else {
          const key = replaceParams(keyFormat, { ...data, ...params });
          if (def.delete) {
            delete cache.map[key];
          } else {
            cache.map[key] = data;
          }
          rebuildCacheList();
        }

        if (entityDef.mock) {
          localStorage.setItem("_mock_" + name, JSON.stringify(cache.list));
        }
      }

      function call(cfg) {
        if (entityDef.mock) {
          return $q.resolve(cfg.data);
        } else {
          return apiCall(cfg);
        }
      }

      function get(def, params = {}, opts = {}) {
        const bypassCache =
          opts.bypassCache === true ||
          (opts.bypassCache === undefined && def.bypassCache);
        let endpoint = replaceParams(
          def.endpoint.replace("#", keyFormat),
          params,
          true
        );
        const result = !bypassCache && getCachedEntity(def, params);

        return result
          ? $q.resolve(result)
          : apiCall({ endpoint, method: def.method || "GET" }).then(v => {
              const onRead = def.onRead || entityDef.onRead;
              const savedVal = onRead ? onRead(v, params, out) : v;
              if (savedVal !== undefined) {
                saveEntity(def, savedVal, params);
              }
              return savedVal;
            });
      }

      function update(def, data, params = {}, opts = {}) {
        let endpoint = replaceParams(
          def.endpoint.replace("#", keyFormat),
          {
            ...data,
            ...params
          },
          true
        );
        return call({
          endpoint,
          method: def.method || "POST",
          data
        }).then(v => {
          // TODO maybe API should consistently return sth
          const onUpdate = def.onUpdate || entityDef.onUpdate;
          const savedVal = onUpdate ? onUpdate(v, data, out) : v || data;
          if (savedVal !== undefined) {
            saveEntity(def, savedVal, { ...data, ...savedVal, ...params });
          }
          return savedVal;
        });
        // TODO handle errors
      }

      function clearCache() {
        cache.list = [];
        cache.map = {};
        cache.listed = false;
      }

      function inCache(key) {
        return !!cache.map[key];
      }

      out.inject = obj => {
        saveEntity({}, obj, {});
      };

      Object.keys(methodDefs).forEach(name => {
        out[name] = createMethod(methodDefs[name], name).bind(out);
      });

      return Object.assign(out, {
        cache,
        clearCache,
        inCache,
        custom: apiCall
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/apiHelper.js